<template>
    <form method="post" @submit="inform">
        <div class="hiddenForm" v-show="false">
            <div id="submitFormData" v-if="formData && formSubmit">
                <input type="text" id="csrf_token" name="csrf_token" v-model="formData.csrf_token">
                <input type="text" name="portal_url" v-model="formData.portal_url">
            </div>
        </div>

        <button type="submit" class="submitButton" v-bind:class="submitClass">
            <p v-if="!attemptingSubmit">
                {{clickText}}
            </p>
            <p v-if="attemptingSubmit">
                {{attemptText}}
                <i class="fa fa-spin fa-circle-o-notch" style="color: #FFF;"></i>
            </p>
        </button>
    </form>
</template>

<script>
export default {

    props: [
        // text to show before user tries to submit
        'clickText',
        // informs this component of the status of any API POST calls being run after using clicks to submit
        'attemptingSubmit',
        // text to show while API POST calls run
        'attemptText',
        // boolean computed from validation check for whether the user should be able to click to submit
        'submitEnabled',
        /*
        ** boolean to determine whether the button should allow a regular HTML form submit or emit a message to the main view instructing it
        ** to run a ajax POST call
        */
        'formSubmit',
        // form data for HTML form submitting, e.g csrf token and portal_id
        'formData'
    ],

    computed: {
        // determine if submit button should have the disabled class
        submitClass() {
            return {
                disabled: !this.submitEnabled
            }
        },
    },

    methods: {
        inform(e) {
            // do nothing if submit isn't enabled
            if (!this.submitEnabled) {
                e.preventDefault();
            } else {
                // prevent event bubbling if this isn't a regular formSubmit
                if (!this.formSubmit) {
                    e.preventDefault();
                }

                // tell main view button was clicked
                this.$emit('button-clicked');
            }
        }
    }
}
</script>

<style scoped>
    .submitButton {
        min-height: 48px;
        width: 100%;
        padding: 8px 24px;
        border: 1px solid #114954;
        border-radius: 16px;
        background: linear-gradient(179.89deg,rgba(255,255,239,0.05) -14.1%,rgba(255,255,191,1e-05) 99.8%),#114954;
        background-color: #114954;
        color: #D4FF26;
        font-size: 20px;
        cursor: pointer;
        font-weight: bold;
        text-align: center;
    }
    .submitButton:hover, .submitButton:focus {
        background: linear-gradient(0deg,rgba(255,255,255,0.1),rgba(255,255,255,0.1)),linear-gradient(180deg,rgba(255,255,255,0.1) 0%,rgba(255,255,255,0) 100%),#114954;
        border-color: #114954;
        transform: translateY(-1px);
    }
    .submitButton:active {
        background: linear-gradient(0deg,rgba(18,31,34,0.05),rgba(18,31,34,0.05)),linear-gradient(179.89deg,rgba(255,255,239,0.05) -14.1%,rgba(255,255,191,1e-05) 99.8%),#114954;
        border-color: #114954;
        transform: translateY(1px);
    }
    .submitButton.disabled {
        pointer-events: none;
        opacity: 0.5;
        color: #D4FF26;
    }

    .submitButton p {
        margin: 0;
    }
    @media only screen and (max-width:640px) {
        .submitButton p {
            font-size: 16px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Generic/ButtonSubmitter.vue